import React from "react";

export const GLPMessage = (props) => {
    const {data, messageTime} = props;
    const glpInfo = data?.additionalData?.glp;
    return <>
        {
            glpInfo?.questions?.length ?
                <div className={"row message-left"}>
                    <div className="col-md-9">
                        <p title={messageTime}>
                            New GLP Record Request: <br/>
                            {
                                <>
                                    {
                                        glpInfo.questions.map((question)=>{
                                            return <div>{question.question}:{question.answer}</div>
                                        })
                                    }
                                </>
                            }
                        </p>
                        <span className={"message-time "}>
                            {messageTime}
                        </span>
                    </div>
                    <div className="col-md-3">
                    </div>
                </div>
                :
                ''
        }
    </>;
}
